import React, { Component } from 'react'
import GoogleButton from  'react-google-button'
import { withRouter } from 'react-router-dom';
import { UserIsNotAuthenticated } from '../../auth';
import { connect } from 'react-redux'
import { firebaseConnect } from 'react-redux-firebase'
import { compose } from 'redux';

class Login extends Component {

  shouldComponentUpdate() {
    return true;
  }

  handleLogin = loginData => {
    this.props.firebase.login(loginData);
  };

  providerLogin = provider => this.handleLogin({ provider, type: 'popup' });

  render() {
    return (
        <div>
          <div style={ { margin: '300px auto', width: '300px' } }>
            <GoogleButton onClick={() => this.providerLogin('google')} />
          </div>

        </div>
    )
  }
}

export default compose(
    UserIsNotAuthenticated,
    firebaseConnect(['projects']),
    connect(
        (state) => ({
          auth: state.firebase.auth,
          authError: state.firebase.authError
        })
    )
)(withRouter(Login))



// WEBPACK FOOTER //
// ./src/containers/login/login.js